import { useGetIdentity, useRecordContext } from "ra-core";
import { ReferenceField } from "@/components/admin/reference-field";
import { ReferenceInput } from "@/components/admin/reference-input";
import { AutocompleteInput } from "@/components/admin/autocomplete-input";
import { ToggleFilterButton } from "@/components/admin/toggle-filter-button";
import { CreateButton } from "@/components/admin/create-button";
import { ExportButton } from "@/components/admin/export-button";
import { TopToolbar } from "../layout/TopToolbar";
import { AccountManagerInput } from "../sales/AccountManagerInput";

export const laneLabel = (l?: any) =>
  l
    ? `${l.origin_city}, ${l.origin_state} → ${l.destination_city}, ${l.destination_state}${l.equipment_type ? ` (${l.equipment_type})` : ""}`
    : "";

export const money = { style: "currency", currency: "USD" } as const;

const SaleName = () => {
  const r = useRecordContext();
  return r ? (
    <span className="font-medium">{`${r.first_name} ${r.last_name}`}</span>
  ) : null;
};

export const OwnerField = (_p: { label?: string }) => (
  <ReferenceField
    source="sales_id"
    reference="sales"
    link={false}
    empty="Unassigned"
  >
    <SaleName />
  </ReferenceField>
);

const LaneName = () => <span>{laneLabel(useRecordContext())}</span>;
export const LaneField = (_p: { label?: string }) => (
  <ReferenceField source="lane_id" reference="lanes" link="edit" empty="-">
    <LaneName />
  </ReferenceField>
);
export const CompanyField = (_p: { label?: string }) => (
  <ReferenceField
    source="company_id"
    reference="companies"
    link="show"
    empty="-"
  />
);

export const CompanyInput = () => (
  <ReferenceInput
    source="company_id"
    reference="companies"
    sort={{ field: "name", order: "ASC" }}
  >
    <AutocompleteInput label="Customer / company" optionText="name" />
  </ReferenceInput>
);
export const LaneInput = () => (
  <ReferenceInput source="lane_id" reference="lanes">
    <AutocompleteInput label="Lane" optionText={laneLabel} />
  </ReferenceInput>
);
export const OwnerInput = () => (
  <div className="flex flex-col gap-1">
    <span className="text-sm font-medium">Assigned agent</span>
    <AccountManagerInput />
  </div>
);

export const MyAccountsFilter = () => {
  const { identity } = useGetIdentity();
  return (
    <ToggleFilterButton
      label="My accounts"
      value={{ sales_id: identity?.id }}
      className="w-auto"
    />
  );
};

export const ListActions = () => (
  <TopToolbar>
    <MyAccountsFilter />
    <ExportButton />
    <CreateButton />
  </TopToolbar>
);

export const equipmentChoices = [
  "Dry Van",
  "Reefer",
  "Flatbed",
  "Step Deck",
  "RGN / Lowboy",
  "Conestoga",
  "Power Only",
  "Hotshot",
  "Box Truck",
  "Other",
].map((n) => ({ id: n, name: n }));
